/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabVirtualizedCommentsLocal = {
    readonly commentsFullyLoaded: boolean | null;
    readonly loadAllButtonHasBeenClicked: boolean | null;
    readonly keyboardShortcutsConfig: {
        readonly key: string;
        readonly source: string;
        readonly reverse: boolean;
    } | null;
    readonly " $refType": "AllCommentsTabVirtualizedCommentsLocal";
};
export type AllCommentsTabVirtualizedCommentsLocal$data = AllCommentsTabVirtualizedCommentsLocal;
export type AllCommentsTabVirtualizedCommentsLocal$key = {
    readonly " $data"?: AllCommentsTabVirtualizedCommentsLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabVirtualizedCommentsLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabVirtualizedCommentsLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsFullyLoaded",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "loadAllButtonHasBeenClicked",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyboardShortcutsConfig",
                    "kind": "LinkedField",
                    "name": "keyboardShortcutsConfig",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reverse",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '704bb6e13c668205e1024bd94454b49f';
export default node;
